import path from "./path.config";

const configs = {
    path
}

export default configs;